/* eslint-disable max-classes-per-file */
import { HttpError } from './HttpError';

/**
 * HTTP 500 Internal Server Error
 * Note: code is 'Error' to match restify-errors behavior
 */
export class InternalError extends HttpError {
  constructor(...args: any[]) {
    super(...args);
    this.name = 'InternalError';
  }
}
InternalError.prototype.statusCode = 500;
InternalError.prototype.code = 'Error';

/**
 * HTTP 400 Bad Request Error
 */
export class BadRequestError extends HttpError {
  constructor(...args: any[]) {
    super(...args);
    this.name = 'BadRequestError';
  }
}
BadRequestError.prototype.statusCode = 400;
BadRequestError.prototype.code = 'BadRequest';

/**
 * HTTP 404 Not Found Error
 */
export class NotFoundError extends HttpError {
  constructor(...args: any[]) {
    super(...args);
    this.name = 'NotFoundError';
  }
}
NotFoundError.prototype.statusCode = 404;
NotFoundError.prototype.code = 'NotFound';

/**
 * HTTP 401 Not Authorized Error
 */
export class NotAuthorizedError extends HttpError {
  constructor(...args: any[]) {
    super(...args);
    this.name = 'NotAuthorizedError';
  }
}
NotAuthorizedError.prototype.statusCode = 401;
NotAuthorizedError.prototype.code = 'NotAuthorized';

/**
 * HTTP 429 Request Throttled Error (Too Many Requests)
 */
export class RequestThrottledError extends HttpError {
  constructor(...args: any[]) {
    super(...args);
    this.name = 'RequestThrottledError';
  }
}
RequestThrottledError.prototype.statusCode = 429;
RequestThrottledError.prototype.code = 'TooManyRequests';

// Export HttpError as well for direct use
export { HttpError };
